// places/index.js
import UsersContainer from './UsersContainer';

export default { UsersContainer };
